import React, { useEffect, useState } from 'react';
import { Form, FloatingLabel, Button } from 'react-bootstrap';
import RichTextEditor from '../RichTextEditor';
import { BsTrash } from 'react-icons/bs';

interface CommunityFormProps {
    ticket_group_code: string;
    items: Item[];
    button_name: string[];
    url: string[];
    onTicketGroupCodeChange: (e: React.ChangeEvent<HTMLSelectElement>) => void;
    onButtonNameChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onUrlChange: (e: React.ChangeEvent<HTMLInputElement>, index: number) => void;
    onAddMore: () => void;
    onDelete: (index: number) => void;
}

interface Item {
    ticket_id: number;
    ticket_group_code: string;
    // Add more properties as per your item structure
}

export default function TicketGroupCode({
    items,
    ticket_group_code,
    button_name,
    url,
    onTicketGroupCodeChange,
    onButtonNameChange,
    onUrlChange,
    onAddMore,
    onDelete,
}: CommunityFormProps) {
    
    return (
        <>
            <Form.Group className="mb-3" controlId="formCategory">
                <Form.Label className='text-sm mb-2'>Ticket Group Code</Form.Label>
                <Form.Select aria-label="Select Category" className='bg-gray-200 py-3' value={ticket_group_code} onChange={onTicketGroupCodeChange}>
                    <option value=""> Select Ticket Group Code</option>
                    {items.map((item) => (
                        <option key={item.ticket_id} value={item.ticket_group_code}>
                            {item.ticket_group_code}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>

            <Form.Group className="mb-3">
                <Form.Label className='text-sm mb-2'>Button and Links</Form.Label>
                {button_name.map((t, index) => (
                    <div key={index} className="d-flex align-items-center mb-3">
                        <Form.Control
                            type="text"
                            placeholder="Button Name"
                            value={button_name[index]}
                            onChange={(e) => onButtonNameChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Form.Control
                            type="text"
                            placeholder="Url"
                            value={url[index]}
                            onChange={(e) => onUrlChange(e as React.ChangeEvent<HTMLInputElement>, index)}
                            className="bg-gray-200 me-2"
                        />
                        <Button variant="secondary" onClick={() => onDelete(index)}>
                            <BsTrash />
                        </Button>
                    </div>
                ))}
                <div>
                    <Button variant="danger" onClick={onAddMore}>
                        Add More
                    </Button>
                </div>
            </Form.Group>
        </>
    );
}
